module.exports = __webpack_public_path__ + "static/img/manual-4.13198d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-4.png
// module id = n1rF
// module chunks = 4